export const CONSTANTS = {
    BASE_PATH : 'https://aocdweb.com/BioTools/cocomaps2/',
    PHP_SCRIPT_BASE_PATH : 'https://aocdweb.com/BioTools/cocomaps2/php/',
    //BASE_PATH : 'http://localhost/',
    //PHP_SCRIPT_BASE_PATH : 'http://localhost/php/'
}